import { createFileRoute, Outlet } from "@tanstack/react-router";

function CheckoutLayout() {
  return <Outlet />;
}

// Layout route for /checkout/** — renders child routes directly.
export const Route = createFileRoute("/checkout")({
  component: CheckoutLayout,
});
